const DISABLE_FEATURE = 'disable-feature';
const ENABLE_FEATURE = 'enable-feature';

export { DISABLE_FEATURE, ENABLE_FEATURE };
